import { render, staticRenderFns } from "./ViewReportHeader.vue?vue&type=template&id=48520ca2&scoped=true&"
import script from "./ViewReportHeader.vue?vue&type=script&lang=js&"
export * from "./ViewReportHeader.vue?vue&type=script&lang=js&"
import style0 from "./ViewReportHeader.vue?vue&type=style&index=0&id=48520ca2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48520ca2",
  null
  
)

export default component.exports